import "./Header.scss"
import LogoLiebherr from "assets/img/logo-liebherr.svg?react"
import IconArrowLeft from "assets/img/icon-arrow-left.svg?react"

import React, { FunctionComponent, ReactNode, useEffect } from "react"
import { useTranslation } from "react-i18next"
import cx from "classnames"

import HeaderTitle from "./HeaderTitle"
import usePageTitle from "hooks/usePageTitle"
import Button from "components/Button/Button"

type HeaderTheme = "default" | "light"

export type HeaderProps = {
    title?: ReactNode
    pageTitle?: string
    theme?: HeaderTheme
    border?: boolean
    logo?: boolean
    backUrl?: string
    onBack?: () => void
}

const Header: FunctionComponent<React.PropsWithChildren<HeaderProps>> = ({
    title,
    pageTitle,
    theme = "default",
    border,
    logo,
    backUrl,
    onBack,
}) => {
    const { t } = useTranslation()
    const { setPageTitle } = usePageTitle()

    useEffect(() => {
        setPageTitle(pageTitle || (typeof title === "string" ? title : undefined))
    }, [pageTitle, setPageTitle, title])

    return (
        <header className={cx([
            "header",
            `header--theme-${theme}`,
            { "header--border": border }
        ])}>
            <div className="header__title">
                {(!!backUrl || !!onBack) &&
                    <Button
                        theme="secondary"
                        type={backUrl ? "link" : "button"}
                        url={backUrl}
                        icon={<IconArrowLeft />}
                        onClick={onBack}
                    />
                }
                {logo &&
                    <div className="header__title-logo">
                        {t('app.abbr')}
                    </div>
                }
                {typeof title === "string"
                    ? <HeaderTitle title={title} />
                    : title
                }
            </div>

            <LogoLiebherr className="header__logo" />
        </header>
    )
}

export default Header
